import { fontSizes as fs } from '../../styles/fonts';
import spacing from '../../styles/spacing';
import { vars } from '../../theme';

/* Input ease has a slowe ease animation (material input) */
export const inputEase = '0.2s ease';

/* Font sizes for all inputs/textareas */
export const fontSize = {
    xxs: {
        fontSize: fs.s12
    },
    xs: {
        fontSize: fs.s14
    },
    sm: {
        fontSize: fs.s16
    },

    md: {
        fontSize: fs.s18
    },

    lg: {
        fontSize: fs.s20
    },

    xl: {
        fontSize: fs.s24
    },

    hg: {
        fontSize: fs.s36
    }
} as const;

/* Sizes */
export const INPUT_SIZE_PROPS = {
    system: {
        xs: {
            height: '24px',
            paddingLeft: spacing[4],
            paddingRight: spacing[4],
            fontSize: '14px',
            borderRadius: '2px'
        },

        sm: {
            height: '36px',
            paddingLeft: spacing[12],
            paddingRight: spacing[12],
            fontSize: '14px'
        },

        md: {
            height: '42px',
            paddingLeft: spacing[12],
            paddingRight: spacing[12],
            fontSize: '16px'
        },

        lg: {
            height: '48px',
            paddingLeft: spacing[16],
            paddingRight: spacing[16],
            fontSize: '18px'
        },
        xl: {
            height: '66px',
            paddingLeft: spacing[20],
            paddingRight: spacing[20],
            fontSize: '20px'
        }
    },
    builder: {
        sm: {
            height: '36px',
            paddingLeft: spacing[12],
            fontSize: '14px'
        },

        md: {
            height: '42px',
            paddingLeft: spacing[12],
            fontSize: '16px'
        },

        xl: {
            height: '64px',
            paddingLeft: spacing[20],
            fontSize: '24px'
        }
    }
} as const;

/* DS border-radius per size — shared by all DS field containers (HBInput, HBTextArea, HBSelect) */
export const DS_FIELD_BORDER_RADIUS: Record<TTextFieldSize, string> = {
    xs: vars.radius.xs,
    sm: vars.radius.xs,
    md: vars.radius.sm,
    lg: vars.radius.md,
    xl: vars.radius.md
};

/* Textfield: (input and textarea) sizes */
export type TTextFieldSize =
    | keyof (typeof INPUT_SIZE_PROPS)['system']
    | keyof (typeof INPUT_SIZE_PROPS)['builder'];
